import React, {Component, createRef} from 'react'
import FJUtil from "../../../util/FJUtil";

import FJButton from "fj-components/FJButton";

import FJCheckIcon from "../../../icon/FJCheckIcon.svg";
import './FJApplyToAll.less'
import FJLocalStore from "../../../store/FJLocalStore";

class FJApplyToAllButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAnimationPlaying: false
        };

        this.mask = createRef();
        this.icon = createRef();
    }

    _onClick = (e) => {
        if (!this.state.isAnimationPlaying && this.props.onClick) {
            this._playing(() => {
                this.props.onClick(e);
            });
        }
    };

    _playing = (callback) => {
        this.setState({isAnimationPlaying: true}, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({isAnimationPlaying: false});
            }, 1000);

            if (callback) {
                callback();
            }
        });
    };

    animation = (time) => {
        this.aniStartTime = this.aniStartTime || time;
        let pastTime = (time - this.aniStartTime) / 1000;
        let mask = this.mask.current;
        let icon = FJUtil.getDOMNode(this.icon.current);
        if (!this.state.isAnimationPlaying) {
            mask.style.setProperty('width', 0);
            mask.style.setProperty('visibility', 'hidden');
            icon.style.setProperty('opacity', 0);
            icon.style.setProperty('visibility', 'hidden');
            this.aniStartTime = 0;
            return;
        }
        mask.style.setProperty('visibility', 'visible');
        icon.style.setProperty('visibility', 'visible');
        if (pastTime >= 0 && pastTime <= 0.4) {
            mask.style.setProperty('width', (pastTime / 0.4) * 100 + '%');
        }
        if (pastTime > 0.4 && pastTime <= 1) {
            mask.style.setProperty('width', '100%');
            icon.style.setProperty('opacity', (pastTime - 0.4) / 0.6);
        }
        if (pastTime > 1) {
            mask.style.setProperty('width', '100%');
            icon.style.setProperty('opacity', 1);
        }
        window.requestAnimationFrame(this.animation);
    };

    render() {
        let {isAnimationPlaying} = this.state;
        let {content} = this.props;
        let className = isAnimationPlaying ? 'playing' : '';
        return (
            <FJButton ghost={true}
                      className='c-apply-to-all-btn'
                      onClick={this._onClick}>
                <div ref={this.mask} className={className}/>
                <FJCheckIcon ref={this.icon} className={className}/>
                <span className='c-button-text'>{content ? content : FJLocalStore._('apply-to-all')}</span>
            </FJButton>
        );
    }
}

export default FJApplyToAllButton;
